module.exports = __webpack_public_path__ + "static/media/twinkle-color-carousel-5.563a0d59.png";